import { RequestManager } from "../utils/request";
import { getCallAPIProvider } from "services/CallAPIProvider";

const { default: BaseInterpreterProvider } = require("./BaseProvider");

class WebProvider extends BaseInterpreterProvider {
  constructor(baseUrl = "", serviceUrl = "") {
    super();

    this.baseUrl = baseUrl;
    this.serviceUrl = serviceUrl;
    this.requestManager = new RequestManager(this.baseUrl);
  }

  async getConfiguration() {
    try {
      this.requestManager.setBaseUrl(this.serviceUrl);
      const configuration = {};
      const url = `/languageandprompt`;
      const res = await this.requestManager.request(
        url,
        "GET",
        "getConfiguration"
      );

      configuration["announcementPrompts"] = [];
      configuration["languageList"] = [];
      if (res?.supportedLanguages) {
        configuration["languageList"] = res?.supportedLanguages;
      }
      if (res?.prompts) {
        configuration["announcementPrompts"] = res?.prompts;
      }
      return configuration;
    } catch (error) {
      console.error(`Error while getting configuration`);
      return error;
    }
  }

  get vidyoConnector() {
    return getCallAPIProvider().vidyoConnector;
  }

  async getSubscriptionToken(conferenceId, localParticipantID, scopes) {
    this.requestManager.setBaseUrl(this.baseUrl);
    const url = `/subscribe`;
    const body = JSON.stringify({
      conferenceId: conferenceId,
      localParticipantScipId: localParticipantID,
      scope: scopes,
    });

    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "getSubscriptionToken",
        body
      );
      return res;
    } catch (error) {
      console.error(JSON.stringify(error));
    }
  }

  async featureDiscovery(conferenceId, remoteParticipantIDs) {
    this.requestManager.setBaseUrl(this.baseUrl);
    const url = `/feature/discover`;
    const body = JSON.stringify({
      conferenceId: conferenceId,
      remoteParticipantScipIdList: remoteParticipantIDs,
    });

    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "featureDiscovery",
        body
      );
      return res;
    } catch (error) {
      console.error(JSON.stringify(error));
    }
  }

  async sendCommand(
    conferenceId,
    remoteParticipantIDs,
    featureId,
    featureKey,
    valueObject
  ) {
    this.requestManager.setBaseUrl(this.baseUrl);
    const url = `/feature/command`;
    const body = JSON.stringify({
      conferenceId: conferenceId,
      remoteParticipantScipId: remoteParticipantIDs,
      featureId: featureId,
      featureKey: featureKey,
      setValue: JSON.stringify(valueObject),
    });

    try {
      const res = await this.requestManager.request(
        url,
        "POST",
        "sendCommand",
        body
      );
      return res;
    } catch (error) {
      console.error(JSON.stringify(error));
    }
  }

  async subscribeToTopic(token, messageCallback, statusCallback) {
    try {
      return this.vidyoConnector.SubscribeToTopic({
        topicSubscriptionToken: token,
        messageCallback: messageCallback,
        statusCallback: statusCallback,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async unsubscribeFromTopic(token) {
    try {
      return this.vidyoConnector.UnsubscribeFromTopic({
        topicSubscriptionToken: token,
      });
    } catch (error) {
      console.error(error);
    }
  }
}

export default WebProvider;
